<app-cancel-open-banking-popin
  (continue)="closeCancelPopin()"
  [show]="isCancelPopinOpen"
></app-cancel-open-banking-popin>

<app-popin [show]="isMakeAChoicePopinOpen" (close)="closeMakeAChoicePopinPopin()">
  <div class="flex flex-col pr-4 pl-4 pb-4 mt-2 text-center">
    <img src="../../../../../assets/images/svg/cross-error.svg" class="place-self-center mb-4" />
    <p class="text-secondary text-xl font-bold mb-4">
      {{ 'impossible_to_continue' | translate }}
    </p>
    <p class="text-secondary text-sm mb-7">
      {{ 'make_choice_to_continue' | translate }}
    </p>
    <div class="flex flex-row justify-center mb-2">
      <button
        (click)="closeMakeAChoicePopinPopin()"
        class="flex-1 text-secondary rounded-full pr-8 pl-8 pt-2 pb-2 bg-primary font-bold"
      >
        {{ 'ok' | translate }}
      </button>
    </div>
  </div>
</app-popin>

<div class="flex flex-col flex-1 h-full">
  <div class="flex-1">
    <p class="text-xs mb-5" [innerHTML]="'ensure_not_select_joined_account' | translate"></p>

    <form id="select-account-form" (ngSubmit)="submit()" [formGroup]="accountsSelectionForm">
      @for (account of foundAccounts(); track account; let i = $index) {
        <label
          [class.border-gray-200]="!accountsSelectionForm.get(account.id)?.value"
          [class.border-primary]="accountsSelectionForm.get(account.id)?.value"
          [for]="account.id"
          class="flex flex-row border-2 rounded-xl p-4 mb-5 cursor-pointer"
        >
          <input
            [formControlName]="account.id"
            [id]="account.id"
            type="checkbox"
            class="place-self-center mr-5 cursor-pointer inline-block align-top appearance-none w-[20px] min-w-[20px] h-[20px] min-h-[20px] mt-1 rounded-[4px] bg-white border border-gray-400 checked:cursor-default checked:bg-primary checked:border-primary checked:bg-[url('/assets/images/svg/validated-check-box.svg')] bg-no-repeat bg-center checked:bg-[length:14px_14px]"
          />
          <div class="flex flex-row justify-between flex-1">
            <div>
              @if (account.type === 'CHECKING' || account.type === 'CARD') {
                <p class="text-xs self-end">{{ 'deposit_account' | translate }}</p>
              }

              @if (account.number !== null) {
                <p class="break-all">
                  <span data-cs-mask>{{ account.number.slice(0, -4) }}</span
                  >{{ account.number.slice(-4) }}
                </p>
              }
              <div
                class="border-2 border-gray-200 flex flex-1 items-center mt-2 rounded-md w-fit pl-2 pr-2 pt-1 pb-1"
              >
                @if (!isTestBankConnector()) {
                  <img [src]="selectedBank().logo" class="w-3 h-3 mr-3" alt="selected bank logo" />
                }
                @if (isTestBankConnector()) {
                  <img
                    src="../../../../../assets/images/test_bank_connector.png"
                    class="w-3 h-3 mr-3"
                    alt="test bank logo"
                  />
                }

                <span class="text-secondary text-xs">{{ selectedBank().name }}</span>
              </div>
            </div>

            <span>
              {{
                account.balance
                  | currency
                    : account.currency ?? ('currency_not_found' | translate)
                    : 'symbol'
                    : '1.2-2'
                    : 'fr'
              }}</span
            >
          </div>
        </label>
      }
    </form>

    <div class="pt-[42px]">
      <button
        class="font-bold text-secondary m-auto flex-1 pt-3 pb-3 rounded-full mb-6 w-full bg-primary"
        form="select-account-form"
        type="submit"
      >
        {{ 'continue' | translate }}
      </button>
      <button
        class="bg-gray-100 font-bold text-secondary m-auto flex-1 pt-3 pb-3 rounded-full mb-6 w-full text-sm"
        (click)="retryBankConnectionWithPartner()"
      >
        {{ 'come_back_to_classic_form' | translate }}
      </button>
    </div>
  </div>
</div>
